import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import ProjectSectionS2 from '../../components/ProjectSectionS2/ProjectSectionS2';
import Footer from '../../components/footer/Footer';
import { Fragment, useContext} from 'react';
import { LanguageContext } from '../../index';

const ProjectPage =() => {
    const { language } = useContext(LanguageContext);
    return(
        <Fragment>
            <Navbar/>
            {language === 'en' ? (
                <PageTitle pageTitle={'Projects'} pagesub={'Our projects'}/> 
            ) : (
                <PageTitle pageTitle={'Projekty'} pagesub={'Nasze realizacje'}/> 
            )}
            <ProjectSectionS2/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ProjectPage;
